import { filtersToParams } from "./server-log.logic";
import type {
	ServerLogDetail,
	ServerLogFilters,
	ServerLogList,
	ServerLogSummary,
} from "./server-log.types";

const BASE = "/api/admin/server-log";

async function getJson<T>(url: string): Promise<T> {
	const res = await fetch(url, { credentials: "include" });
	if (!res.ok) throw new Error(`Server log request failed (${res.status})`);
	return (await res.json()) as T;
}

export const fetchServerLogList = (f: ServerLogFilters, page: number) =>
	getJson<ServerLogList>(`${BASE}?${filtersToParams(f, page)}`);

export const fetchServerLogDetail = async (id: string) =>
	(await getJson<{ data: ServerLogDetail }>(`${BASE}/${id}`)).data;

export const fetchServerLogModules = async () =>
	(await getJson<{ data: string[] }>(`${BASE}/modules`)).data;

export const fetchServerLogSummary = () =>
	getJson<ServerLogSummary>(`${BASE}/summary`);

export const serverLogExportUrl = (f: ServerLogFilters) =>
	`${BASE}/export.csv?${filtersToParams(f)}`;

export async function updateServerLogStatus(
	id: string,
	status: "open" | "resolved" | "ignored",
	note: string,
): Promise<void> {
	const res = await fetch(`${BASE}/${id}`, {
		method: "PATCH",
		credentials: "include",
		headers: { "content-type": "application/json" },
		body: JSON.stringify({ status, note: note.trim() || undefined }),
	});
	if (!res.ok) throw new Error(`Update status failed (${res.status})`);
}
